// src/hooks/useConfirmExit.js
import { useCallback } from 'react';
import { toast } from 'react-toastify';

export const useConfirmExit = ({
  isDirty,
  onConfirm,
  toastMessage = 'You have unsaved changes',
  confirmMessage = 'Leave without saving?'
}) => {
  return useCallback(() => {
    // If nothing is dirty, allow immediately
    if (!isDirty) {
      onConfirm?.();
      return Promise.resolve(true);
    }

    return new Promise((resolve) => {
      const toastId = toast.warn(
        ({ closeToast }) => (
          <div>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>
              {toastMessage}
            </div>

            <div style={{ marginBottom: 10 }}>
              {confirmMessage}
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => {
                  closeToast();
                  resolve(false); // STAY
                }}
              >
                Stay
              </button>

              <button
                className="btn btn-sm btn-danger"
                onClick={() => {
                  closeToast();
                  onConfirm?.();
                  resolve(true); // LEAVE
                }}
              >
                Leave
              </button>
            </div>
          </div>
        ),
        {
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          draggable: false,
        }
      );
    });
  }, [isDirty, onConfirm, toastMessage, confirmMessage]);
};
